import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../../store';
import { EUserType } from '../../constants/requestDemand';
import { trackBackToOffer, trackCloseBannerPopup, trackCloseSmsPopup } from '../../components/demand/utils/tracking';
import { closeDemandRequestModal } from './requestDemand';

export const closeForm = (): ThunkAction<void, IState, IContext> => {
  return (dispatch, getState) => {
    const {
      requestDemand: { selectedUserType, isSuccessModalOpen, isSmsVerificationModalOpen },
    } = getState();
    const isHomeOwner = selectedUserType === EUserType.HOME_OWNER;

    dispatch(closeDemandRequestModal());

    if (isSuccessModalOpen) {
      return trackBackToOffer(isHomeOwner);
    }

    if (isSmsVerificationModalOpen) {
      trackCloseSmsPopup(isHomeOwner);
    }

    trackCloseBannerPopup(isHomeOwner);
  };
};
